<!-- Template -->

<template>
    <div v-if="visible" name="modal">
        <div
            class="modal modal-mask"
            style="display: block;"
            id="modal-edit-ticket"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-edit-ticket"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <!-- Header -->

                    <div class="modal-header">
                        <h4 class="modal-title modal-title-with-back" v-if="!loading"><a @click.prevent="back" v-show="showBack">
                                <span class="icon-chevron-left"></span>
                            </a> <span>#{{ticket.id}} {{ticket.shortSummary}}</span></h4>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <span v-if="loading" class="spinner-border modal-loader"></span>
                        
                        <div class="header ticket-info" v-if="!loading">
                            <p><span class="ticket-label">System:</span> {{ticket.dhrNumber}} {{ticket.productConfiguration}}</p>
                            <p v-if="ticket.createdInPortal"><span class="ticket-label" >Ticket raised by:</span> {{ticket.createdByContact}}</p>
                            <p v-if="!ticket.createdInPortal"><span class="ticket-label" >Ticket raised by:</span> -</p>
                            <p v-if="ticket.createdInPortal && ticket.contactEmail"><span class="ticket-label" >Contact:</span> <a class="mt-0" :href="`mailto:${ticket.contactEmail}`" target="_blank">{{ticket.contactEmail}}</a></p>
                            <p v-else><span class="ticket-label" >Contact:</span> - </p>
                            <p><span class="ticket-label">Nature of the issue:</span><span v-if="ticket.supportTicketNatureId == 1">Technical</span><span v-else>Clinical</span></p>
                            <p><span class="ticket-label">System is operable:</span> <span v-if="ticket.systemOperable">Yes</span><span v-else>No</span></p>
                            <p><span class="ticket-label">Status:</span>{{ticket.status}}</p>
                            <p><span class="ticket-label">Date <span v-if="ticket.status == 'Open'">opened:</span><span v-else>closed:</span></span>{{ticket.date}} </p>
                            <p><span class="ticket-label">Last updated:</span>{{ticket.lastUpdated}}</p>                            
                            <!-- <p><span class="ticket-label">Priority:</span>{{ticket.priority}}</p>                             -->
                        </div>

                        <div class="ticket-data mt-3" v-if="ticket.description && !loading">
                            <div><pre>{{ticket.description.replace('↵','\n')}}</pre></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- Script -->

<script>
    import { HospitalService } from '@/services/hospital-service';
    export default {
        name: "TicketDetailsReadOnly",

        props:['showBack'],

        data() {
            return {
                visible: false,
                ticket: null, 
                system: null,
                loading: true,
                contactDetails: null
            };
        },

        created() {  
            this.hospitalService = new HospitalService(this.$api, this.$store);              
        },

        methods: {
            async show(data) {

                if(data.system != undefined){
                    this.system = data.system;
                    this.ticket = data.ticket;
                }else{
                    this.ticket = data;
                }
                this.visible = true;   
                
                if(data.createdByContactID){
                    this.contactDetails = await this.hospitalService.getContact(data.createdByContactID);
                    this.ticket.contactEmail = this.contactDetails.email;
                }else{
                    this.ticket.contactEmail = null;
                }
                this.loading = false;
            },

            close() {
                this.visible = false;
                this.loading = true;
            },

            back(){
                this.visible = false;
                this.loading = true;
                this.$emit('close', this.system);
            }
        }
    }
</script>

